// extracted by mini-css-extract-plugin
export default {"AccordionItem":"AccordionItem_AccordionItem__FM+hK","Question":"AccordionItem_Question__q+eBY","Answer":"AccordionItem_Answer__XPs9M","Open":"AccordionItem_Open__0PPIy"};